import Button from "../UI/Button";
import {
  dialogNotify,
  displayNotImplemented,
} from "../../services/Notifications/NotificationServices";
import Select from "../UI/Select";
import ProfileEditModal from "../../../pages/Cabinet/components/ProfileEditModal/ProfileEditModal";
import { useEffect, useState } from "react";
import axios from "axios";
import usePlayerAvatar from "../../../pages/Cabinet/hooks/usePlayerAvatar";
import { initiateLogout } from "../../../pages/Login/services/authService";
function getLogin() {
  return localStorage.getItem("username");
}

function isLogged() {
  return getLogin() != null;
}

function exit() { 
  initiateLogout()
}

function Navbar() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const buttons = (
    <>
      <Button href="/login" className="navbar_loginButton">
        Войти
      </Button>
      <Button href="/register" className="navbar_registrationButton">
        Регистрация
      </Button>
    </>
  );

  const {data} = usePlayerAvatar(getLogin() || "")

  const avatar = data?.avatar_link

  const bucketUrl = window.location.hostname == 'cybershtab.ru'? 'https://media.cybershtab.ru/cybershtab-front': 'http://10.244.0.242:9000/cybershtab-local-bucket'

  const userInfo = (
    <>
      <div className="navbar_userInfo">
        <a href="/Cabinet">
          <img className="navbarAvatar" src={ avatar? ( bucketUrl+ "/"+avatar): "/Main/avatar.jpg"} alt="" />
        </a>
        {getLogin()}
      </div>
    </>
  );

  const content = !isLogged() ? buttons : userInfo;

  const profileOption = (
    <a className="select_option" href={`/Cabinet/${getLogin()}`}>
      Профиль
    </a>
  );
  const editProfileOption = (
    <a onClick={() => setIsOpen(true)} className="select_option" href={"#"}>
      Редактировать профиль
    </a>
  );
  const exitOption = (
    <a className="select_option" onClick={exit}>
      Выйти
    </a>
  );

  return (
    <>
      {isOpen && (
        <ProfileEditModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        ></ProfileEditModal>
      )}
      <nav className="bordered navbar">
        <img className="navbarSkull" src="/skull.svg" alt="" />
        <a className="navbar-ref" href="/promo">
          Главная
        </a>
        <a className="navbar-ref" href="/calendar">
          Игры
        </a>
        <a
          onClick={() => {
            displayNotImplemented();
          }}
          className="navbar-ref"
        >
          <img className="navbar-search-icon" src="/search.svg" alt="Поиск" />
        </a>
        {isLogged() ? (
          <div className="navbar-select-wrapper">
            <Select
              options={[profileOption, editProfileOption, exitOption]}
              value={content}
              isChangeable={false}
            ></Select>
          </div>
        ) : (
          content
        )}
      </nav>
    </>
  );
}

export default Navbar;
